import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";

import { TextField, SelectField, Loadable } from "components/support";

class CompanyFormGeographicInfo extends Component {
  static States = [
    "RO",
    "AC",
    "AM",
    "RR",
    "PA",
    "AP",
    "TO",
    "MA",
    "PI",
    "CE",
    "RN",
    "PB",
    "PE",
    "AL",
    "SE",
    "BA",
    "MG",
    "ES",
    "RJ",
    "SP",
    "PR",
    "SC",
    "RS",
    "MS",
    "MT",
    "GO",
    "DF"
  ];

  constructor(props) {
    super(props);
    props.viewModel.company = props.company;
  }

  handleZipcodeChange = value => {
    this.props.company.address.zipcode = value;
    this.props.presenter.onZipcodeChange();
  };

  render() {
    const { viewModel, company, errors } = this.props;
    const { address } = company;
    const { loading } = viewModel;

    return (
      <div className="grid-container">
        <Row>
          <Col xs={12}>
            <Loadable loading={loading}>
              <div className="grid-container mt-sm mb-sm">
                <Row>
                  <Col xs={12} lg={4}>
                    <TextField
                      floatingLabelFixed={true}
                      floatingLabelText="CEP"
                      maskPattern={[
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        "-",
                        /\d/,
                        /\d/,
                        /\d/
                      ]}
                      maxLength={8}
                      type="tel"
                      value={address.zipcode}
                      errorText={errors["address.zipcode"]}
                      onChange={(_, value) => this.handleZipcodeChange(value)}
                      underlineShow={false}
                      required
                      fullWidth
                    />
                  </Col>
                  <Col xs={6} lg={2}>
                    <SelectField
                      floatingLabelFixed={true}
                      floatingLabelText="Estado"
                      value={address.state}
                      errorText={errors["address.state"]}
                      onChange={(_, value) => (address.state = value)}
                      underlineStyle={{ bottom: "0" }}
                      labelStyle={{ height: "44px" }}
                      fullWidth
                      options={CompanyFormGeographicInfo.States.map(state => {
                        return {
                          value: state,
                          label: state
                        };
                      })}
                    />
                  </Col>
                  <Col xs={6} lg={3}>
                    <TextField
                      floatingLabelFixed={true}
                      floatingLabelText="Cidade"
                      maxLength={34}
                      value={address.city}
                      errorText={errors["address.city"]}
                      onChange={(_, value) => (address.city = value)}
                      underlineShow={false}
                      required
                      fullWidth
                    />
                  </Col>
                  <Col xs={12} lg={3}>
                    <TextField
                      floatingLabelFixed
                      floatingLabelText="Código do Município"
                      maxLength={7}
                      maskPattern={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                      type="tel"
                      value={company.fiscal_informations.municipal_code}
                      errorText={errors["fiscal_informations.municipal_code"]}
                      onChange={(_, value) =>
                        (company.fiscal_informations.municipal_code = value)
                      }
                      underlineShow={false}
                      required
                      fullWidth
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} lg={6}>
                    <TextField
                      floatingLabelFixed={true}
                      floatingLabelText="Bairro"
                      maxLength={34}
                      value={address.neighborhood}
                      errorText={errors["address.neighborhood"]}
                      onChange={(_, value) => (address.neighborhood = value)}
                      underlineShow={false}
                      required
                      fullWidth
                    />
                  </Col>
                  <Col xs={12} lg={6}>
                    <TextField
                      floatingLabelFixed={true}
                      floatingLabelText="Logradouro"
                      maxLength={34}
                      value={address.street}
                      errorText={errors["address.street"]}
                      onChange={(_, value) => (address.street = value)}
                      underlineShow={false}
                      required
                      fullWidth
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} lg={4}>
                    <TextField
                      floatingLabelFixed={true}
                      floatingLabelText="Número"
                      maxLength={5}
                      type="tel"
                      value={address.number}
                      errorText={errors["address.number"]}
                      onChange={(_, value) => (address.number = value)}
                      underlineShow={false}
                      required
                      fullWidth
                    />
                  </Col>
                  <Col xs={12} lg={8}>
                    <TextField
                      floatingLabelFixed={true}
                      floatingLabelText="Complemento"
                      maxLength={34}
                      value={address.complement}
                      errorText={errors["address.complement"]}
                      onChange={(_, value) => (address.complement = value)}
                      underlineShow={false}
                      fullWidth
                    />
                  </Col>
                </Row>
              </div>
            </Loadable>
          </Col>
        </Row>
      </div>
    );
  }
}

export default CompanyFormGeographicInfo;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/geographic-info/geographic-info.view.jsx